import { render, staticRenderFns } from "./generalPrint.vue?vue&type=template&id=2514258e&scoped=true&"
import script from "./generalPrint.vue?vue&type=script&lang=js&"
export * from "./generalPrint.vue?vue&type=script&lang=js&"
import style0 from "./generalPrint.vue?vue&type=style&index=0&id=2514258e&prod&scoped=true&lang=css&"
import style1 from "./generalPrint.vue?vue&type=style&index=1&id=2514258e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514258e",
  null
  
)

export default component.exports